import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import {LEARN_MORE_DIR} from '../data/learnmore';
import { LangService } from '../../core/lang.service';
import { BreadcrumbsService, IBreadcrumbRoute } from '../../core/breadcrumbs.service';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { LoginGuardService } from '../../api/login-guard.service';
import { AccountType } from '../../constants/account-types';



@Component({
  selector: 'learnmore-display',
  templateUrl: './learnmore-display.component.html',
  styleUrls: ['./learnmore-display.component.scss']
})
export class LearnmoreDisplayComponent implements OnInit, OnDestroy {

  @Input() breadcrumbPre: IBreadcrumbRoute[];
  @Input() directoryPrefix: string;
  @Input() accountType: AccountType;
 
  public breadcrumb = [];
  public activeTopic;
  public activeSubTopic;
  public currentArticleContent: string;
  public isMobileLinksCollapsed = true;

  private dir = LEARN_MORE_DIR;
  private baseRoute = '/';
  private routeSub: Subscription;

  constructor(
    public lang: LangService,
    private route: ActivatedRoute,
    private loginGuard: LoginGuardService, //
    private breadcrumbsService: BreadcrumbsService
  ) { }

  ngOnInit() {
    this.loginGuard.deactivate();
    this.routeSub = this.route.params.subscribe(e => this.onRouteChange(e));
  }

  ngOnDestroy() {
    if (this.routeSub) {
      this.routeSub.unsubscribe();
    }
  }

  getArticleContent(path) {
    const docId: string = ['learnmore', this.directoryPrefix, path].join(':');
    return this.lang.tra(docId) || '';
  }

  toggleMobileLinksCollapse() {
    this.isMobileLinksCollapsed = !this.isMobileLinksCollapsed;
  }

  onRouteChange(routeParams: any) {
    const topicPath: string = routeParams['topicPath'];
   // this.baseRoute = this.breadcrumbPre[this.breadcrumbPre.length - 1].route + '/'; // could be called just once, not on each route change
   if(this.accountType === 'test-admin'){
    this.baseRoute = this.breadcrumbsService.TESTADMIN_LEARNMORE().route + '/'
   }
   else{
    this.baseRoute = this.breadcrumbsService.APPLICANT_LEARNMORE().route + '/'
   }
    this.breadcrumb = [].concat(this.breadcrumbPre || []); // reset

    // select the active path
    this.activeTopic = null;
    this.activeSubTopic = null;
    if (topicPath) {
      const topicPathArr = topicPath.split(':');
      const topicId = topicPathArr[0];
      const subtopicId = topicPathArr[1];
      this.getTopics().forEach(topic => {
        // console.log('>>', this.getTitleTranlsated(topic.path))
        if (topic.id === topicId) {
          this.activeTopic = topic;
          if (subtopicId && topic.sub) {
            topic.sub.forEach(subtopic => {
              // console.log('>>', this.getTitleTranlsated(subtopic.path))
              if (subtopic.id === subtopicId) {
                this.activeSubTopic = subtopic;
              }
            });
          }
        }
      });

      // scroll up and, if mobile, collapse
      window.scrollTo(0, 0);
      this.isMobileLinksCollapsed = true;


      // breadcrumbs
      if (this.activeTopic) {
        this.breadcrumb.push({
          caption: this.getTitleTranlsated(this.activeTopic.path),
          route: this.baseRoute + this.activeTopic.path,
        });
      }
      if (this.activeSubTopic) {
        this.breadcrumb.push({
          caption: this.getTitleTranlsated(this.activeSubTopic.path),
          route: this.baseRoute + this.activeSubTopic.path,
        });
      }

      // article content
      if (this.activeSubTopic) {
        this.currentArticleContent = this.getArticleContent(this.activeSubTopic.path);
      } else if (this.activeTopic) {
        this.currentArticleContent = this.getArticleContent(this.activeTopic.path);
      }

    }
  }

  getTitleTranlsated(route: string) {
    const slug = [
      'lm_title',
      this.directoryPrefix,
      route
    ].join(':');
    return this.lang.tra(slug);
  }

  getActiveTopicCaption() {
    if (this.activeSubTopic) {
      return this.getTitleTranlsated(this.activeSubTopic.path);
    } else if (this.activeTopic) {
      return this.getTitleTranlsated(this.activeTopic.path);
    }
    return '';
  }

  getTopics(): any[] {
    let rootNode = this.dir[0]; // use the first topic as a default root node
    this.dir.forEach(node => {
      if (node.id === this.directoryPrefix) {
        rootNode = node;
      }
    });
    return rootNode.sub;
  }

  // getSubTopics(topic){
  //   const directory = this.getTopics();
  //   let targetNode;
  //   if (this.directory){
  //     /// ...
  //     let directorId = this.directory[0]
  //     directory.forEach(node => {
  //       if (node.id === directorId){
  //         targetNode = node;
  //       }
  //     });
  //     if (targetNode){
  //       return targetNode.sub;
  //     }
  //   }
  // }

  isTopicSelected(topic) {
    return topic === this.activeTopic;
  }
  isSubTopicSelected(subTopic) {
    return subTopic === this.activeSubTopic;
  }

  getNodePath(node) {
    return this.baseRoute + node.path;
  }

  // selectTopic(topic, subtopic){
  //   console.log('topic, subtopic', topic, subtopic)

  //   // if (node.path){

  //   // }
  //   // else if (node.){

  //   // }
  // }

}
